import React from 'react'

const Footer = () => (
  <footer className="footer">
    <div className="container">
      <div className="left">
        <h2>farmhand</h2>
        <p>{(new Date().getFullYear())} &copy; Farmhand. All rights reserved.</p>
      </div>
    </div>
  </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./components/Footer.js